"use client";

import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Step {
    n: number;
    label: string;
}

interface StepBadgesProps {
    steps: Step[];
    currentStep: number;
    className?: string;
}

/** Horizontal step-progress row used by miniapp create panels. Lifted into
 *  the shared `components/ui` layer so the web mobile views (Try-On,
 *  Photoshoot, AI Photo Studio, Headshot) can render the same component
 *  on their phone-width breakpoint and feel consistent with the miniapp.
 */
export function StepBadges({ steps, currentStep, className }: StepBadgesProps) {
    return (
        <div className={cn("flex items-center gap-1.5 px-1", className)}>
            {steps.map((s, i) => {
                const isDone = currentStep > s.n;
                const isActive = currentStep >= s.n;
                return (
                    <div key={s.n} className="flex items-center gap-1.5 flex-1 min-w-0">
                        <div className={cn(
                            "w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold transition-colors shrink-0",
                            isActive
                                ? "bg-amber-500/20 text-amber-400 border border-amber-500/30"
                                : "bg-muted/30 text-muted-foreground/40 border border-border/40"
                        )}>
                            {isDone ? <CheckCircle2 className="w-3 h-3" /> : s.n}
                        </div>
                        <span className={cn(
                            "text-[10px] font-medium truncate",
                            isActive ? "text-foreground/80" : "text-muted-foreground/40",
                        )}>
                            {s.label}
                        </span>
                        {i < steps.length - 1 && <div className="flex-1 h-px bg-border/40 min-w-[8px]" />}
                    </div>
                );
            })}
        </div>
    );
}
